import { render, staticRenderFns } from "./DaOptional.vue?vue&type=template&id=b54af240&"
import script from "./DaOptional.vue?vue&type=script&lang=js&"
export * from "./DaOptional.vue?vue&type=script&lang=js&"
import style0 from "./DaOptional.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports